import { useState, useEffect } from 'react';

const DurationTimer = ({
  completed = false,
  startTime,
  finishedAt,
}: {
  completed?: boolean;
  startTime: Date;
  finishedAt?: Date | null;
}) => {
  const [duration, setDuration] = useState<string | null>(null);

  useEffect(() => {
    let interval;
    const updateDuration = () => {
      const now = finishedAt ? new Date(finishedAt) : new Date();
      const diffMs = now.getTime() - startTime.getTime();

      // Convert to seconds, minutes, hours
      const seconds = Math.floor((diffMs / 1000) % 60);
      const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
      const hours = Math.floor(diffMs / (1000 * 60 * 60));

      // Format with leading zeros
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      if (now < startTime) {
        setDuration('00:00:00');
        return;
      }

      setDuration(`${formattedHours}:${formattedMinutes}:${formattedSeconds}`);
    };

    updateDuration();

    if (completed === true) {
      clearInterval(interval);
    }

    if (!finishedAt && !completed) {
      interval = setInterval(updateDuration, 1000);
      return () => clearInterval(interval);
    }
  }, [completed]);

  return duration;
};

export default DurationTimer;
